import { Stack } from "@mui/material";
import React from "react";

import Logo from "../../../assets/images/logo_gray.svg";

export const AppFooter: React.FC = () => (
    <Stack direction="column" alignItems="center" spacing={4} component="footer" maxWidth="80vw">
        <Logo />
        {/* <Typography variant="label1" color="text.disabled" fontWeight="regular">
            Levro, Inc. is a financial technology company and is not a bank; FDIC insurance subject to certain limits of
            banking service provider. Banking services provided by Blue Ridge Bank N.A.; Member FDIC. Payment services
            are provided by The Currency Cloud Limited. Registered in England No. 06323311. Registered Office: The
            Steward Building 1st Floor, 12 Steward Street London E1 6FQ. The Currency Cloud Limited is authorised by the
            Financial Conduct Authority under the Electronic Money Regulations 2011 for the issuing of electronic money
            (FRN: 900199). In the US Currency Cloud operates in partnership with CFSB. CFSB fully owns the bank program
            and services are provided by The Currency Cloud Inc.
        </Typography> */}
    </Stack>
);
